

















import { Component, Prop, Vue } from "vue-property-decorator";
import { AxTooltip } from '@/axiom';

@Component({
    name:"IconButton",
    components: {
    },
})
export default class IconButton extends Vue {
    @Prop({ required: false }) public id: string;
    @Prop({ required: false }) public title: string;
    @Prop({ required: false }) public href: string;
    @Prop({ required: false }) public onClick: any;

    public mounted() {
        if (!(this.$el as HTMLElement).title || (this.$el as HTMLElement).title.length === 0) return;
        AxTooltip.init((this.$el as HTMLElement));
        AxTooltip.setProp((this.$el as HTMLElement), 'offset', [0, 14]);
    }
}
